import React from 'react'

function UnknownPage() {
  return <>404</>
}

export default UnknownPage
